import { useState, useRef } from "react";
import {
  ContainerCenter as Content,
  Header,
  MainContainer,
  Togle,
  ToggleMinhasTarefas,
  ToggleTodasTarefas,
  TopDiv,
  InputDiv,
  Table,
  ToggleTest,
  TaskList,
} from "./styles";

import TopBar from "../../components/general/TopBar";
import Search from "../../assets/icons/Search";
import HeaderTable from "./Table/Header";
import ProjectIteraction from "./ProjectIteraction";
import Input from "../../components/general/Input";
import Menu from "../../components/general/Menu";
import ReactLoading from "react-loading";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useOutsideDrop } from "../../hooks/useOutsideDrop";
import { useVerifyToken } from "../../hooks/useVerifyToken";
import { useDispatch, useSelector } from "react-redux";
import { toastAlert } from "../../components/Toastify/index";
import { useEffect } from "react";
import { fetchActivedTasks } from "../../state/activedTasks/reducers";
import { useHistory } from "react-router";
import { TaskOptions } from "./TaskOptions/index";
import { ProtectedComponent } from "../../components/general/Protected/index";
import TaskStatusSelector from "./TaskStatusSelector";
import Pagination from "../../components/general/Pagination/index";
import TasksModal from "./PaginationTasksModal";

export const getBaseFilters = (params) => {
  return {
    label: params.get("label") ? params.get("label") : "",
    tasksACC: params.get("tasksACC") === "true" ? true : false,
    flowTitle: params.get("flowTitle") ? params.get("flowTitle") : "",
    client: params.get("client") ? params.get("client") : "",
    taskId: params.get("taskId") ? params.get("taskId") : "",
    userId: params.get("userId") ? params.get("userId") : "",
    alpha: params.get("alpha") ? params.get("alpha") === "true" : false,
    creation: params.get("creation")
      ? params.get("creation") === "true"
      : false,
    status: params.get("status") ? params.get("status") : "doing",
    page: params.get("page") ? parseInt(params.get("page")) : 1,
  };
};

const ToggleComponent = ({ type }) => {
  const [typeFilter, updateFilters] = type;

  const toggle = !typeFilter.tasksACC;

  return (
    <Togle>
      <ToggleTest toggleState={toggle} />
      <ToggleMinhasTarefas
        toggleState={toggle}
        onClick={() => {
          updateFilters({ ...typeFilter, tasksACC: true });
        }}
      >
        Minhas Tarefas
      </ToggleMinhasTarefas>
      <ToggleTodasTarefas
        toggleState={toggle}
        onClick={() => {
          updateFilters({ ...typeFilter, tasksACC: false });
        }}
      >
        Todas Tarefas
      </ToggleTodasTarefas>
    </Togle>
  );
};

const TasksPage = ({ location }) => {
  //? false = minhas tarefas, true = Todas as tarefas

  const user = useSelector((state) => state.auth.user);

  const rank = user?.rank ?? "none";

  // filter control on frontend
  const [filterOpen, setFilterOpen] = useState(false);

  const tasks = useSelector((state) => state.activedTasks);
  const { status, pages, pagination } = tasks;
  const notificationState = location.state?.notification;

  //url Params
  const params = new URLSearchParams(location.search);

  const [labelSearch, setLabelSearch] = useState(
    params.get("label") ? params.get("label") : ""
  ); //filtrar rótulo da tarefa

  const [clientSearch, setClientSearch] = useState(
    params.get("clientSearch") ? params.get("clientSearch") : ""
  ); //filtrar nome do cliente

  const [flowSearch, setFlowSearch] = useState(
    params.get("flowSearch") ? params.get("flowSearch") : ""
  ); //filtrar por projeto de fluxo
  const [typeFilter, setTypeFilter] = useState(getBaseFilters(params));

  const { promiseInProgress: isFetching } = usePromiseTracker({
    area: "fetchActivedTasks",
  });

  const [openTask, setOpenTask] = useState({ isOpen: false, current: {} });
  const [enableFetch, setEnableFetch] = useState(
    !notificationState ? true : false
  );

  const updateFilters = ({ ...typeFilter }) => {
    setTypeFilter({ ...typeFilter });
    setUrlParams({ ...typeFilter });
  };

  const setUrlParams = ({ ...typeFilter }) => {
    history.push({
      search:
        "?" +
        new URLSearchParams({
          ...typeFilter,
        }).toString(),
    });
  };

  const history = useHistory();

  const containerRef = useRef(null);
  useOutsideDrop(containerRef, () => {
    setFilterOpen(false);
  });

  useVerifyToken();

  const dispatch = useDispatch();

  async function fetchingActivedTasks(filters) {
    trackPromise(
      dispatch(
        fetchActivedTasks({
          queries: {
            filters: filters ? filters : typeFilter,
          },
          page: filters?.page ? filters.page : typeFilter.page,
        })
      ).then((res) => {
        if (res?.error) {
          toastAlert({
            msg: `Ocorreu um erro ao carregar os projetos: '${res.payload.error}'`,
            isError: true,
          });
        }
      }),
      "fetchActivedTasks"
    );
  }

  useEffect(() => {
    let isMounted = true;

    //enable fetch serve para verificar se o usuário veio até aqui por meio de notificação
    if (isMounted && enableFetch) {
      fetchingActivedTasks();
    }

    return () => (isMounted = false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeFilter]);

  useEffect(() => {
    if (notificationState) {
      const filters = {
        taskId: params.get("taskId"),
        status: params.get("status"),
        page: 1,
      };
      fetchingActivedTasks(filters);
      setEnableFetch(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationState]);

  return (
    <>
      <TopDiv>
        <Menu />
        <MainContainer>
          <TopBar
            text={
              typeFilter.taskFilter === "all"
                ? "Tarefas > Todas Tarefas"
                : "Tarefas > Minhas Tarefas"
            }
          />
          <Content>
            <Header>
              <ProtectedComponent rank={rank} allowed={["gerente", "admin"]}>
                <ToggleComponent type={[typeFilter, updateFilters]} />
              </ProtectedComponent>
              <InputDiv>
                <Input
                  value={labelSearch}
                  setValue={setLabelSearch}
                  Icon={() => <Search />}
                  placeholder="Pesquisar por Tarefa..."
                  buttonConfirm
                  buttonConfirmText="Pesquisar"
                  onClickButton={() => {
                    updateFilters({ ...typeFilter, label: labelSearch });
                  }}
                />
              </InputDiv>
              <TaskOptions
                params={params}
                open={filterOpen}
                setOpen={setFilterOpen}
                type={typeFilter}
                setType={updateFilters}
                clientSearch={clientSearch}
                setClientSearch={setClientSearch}
                flowSearch={flowSearch}
                setFlowSearch={setFlowSearch}
              />
            </Header>
            <TaskStatusSelector
              params={params}
              type={typeFilter}
              setType={updateFilters}
            />
            <Table>
              <HeaderTable />

              {!isFetching ? (
                <TaskList>
                  <ProjectIteraction
                    setTask={setOpenTask}
                    pagination={pagination}
                    status={status}
                    pages={pages}
                  />
                </TaskList>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "1rem",
                  }}
                >
                  <ReactLoading type="bars" color="#118052" />
                </div>
              )}
            </Table>
          </Content>
        </MainContainer>
        <Pagination
          style={{
            position: "absolute",
            bottom: "1.5rem",
            left: "50%",
          }}
          actualPage={typeFilter.page}
          onPageChange={(activePage) => {
            updateFilters({
              ...typeFilter,
              page: activePage,
            });
          }}
          numberOfPages={pages}
        />
      </TopDiv>
      {openTask.isOpen ? (
        <>
          <TasksModal
            current={openTask.current}
            isOpen={openTask.isOpen}
            onClose={() => setOpenTask({ current: {}, isOpen: false })}
            type={[typeFilter, setTypeFilter]}
          />
        </>
      ) : null}
    </>
  );
};

export default TasksPage;
